import { render, staticRenderFns } from "./ZhangBen.vue?vue&type=template&id=6f2e13f6&"
import script from "./ZhangBen.vue?vue&type=script&lang=js&"
export * from "./ZhangBen.vue?vue&type=script&lang=js&"
import style0 from "./ZhangBen.vue?vue&type=style&index=0&id=6f2e13f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports